
  import { computed, defineComponent, onBeforeMount, ref } from 'vue';
  import { Container } from '@/ui/components/Container';
  import { PageTitle } from '@/ui/components/PageTitle';
  import { Box } from '@/ui/components/Box';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { Button } from '@/ui/components/Button';
  import { parseInt10, pushRoute } from '@/ui/helpers';
  import { currency, getList, yearlyPrice } from '@/services/chargebee/availablePlans';
  import { Loader } from '@/ui/components/Loader';
  import FreeTrialModal from '@/ui/components/modals/FreeTrialModal.vue';
  import { SubscriptionSlugNickName } from '@/entities/subscription/constants';
  import { fetchUser, getOrganizationUsersCount, hasSubscription, isOnFreePlan, user } from '@/ui/auth/auth';
  import { PlanNickName } from '@/entities/plan/constants';
  import { startTrial } from '@/services/api/resources/chargebee/subscription/actions';
  import { isDisableFreePlanEnabled } from '@/ui/helpers/featureHelper';

  export default defineComponent({
    name: 'EndOfTrial',
    components: {
      Container,
      PageTitle,
      Box,
      PageSubtitle,
      Button,
      Loader,
      FreeTrialModal,
    },
    props: [],
    setup() {
      const notOnFreePlan = hasSubscription() && !isOnFreePlan.value;
      const onFreePlanAndFeatureDisabled = hasSubscription() && isOnFreePlan.value && !isDisableFreePlanEnabled();

      onBeforeMount(() => {
        if (notOnFreePlan || onFreePlanAndFeatureDisabled) {
          pushRoute({ name: 'home' });
        }
      });

      const showFreeTrialPreviewModal = ref(false);
      const isLoading = ref(false);
      const price = computed(() => yearlyPrice.value
        ? (parseInt10(yearlyPrice.value) / 12).toFixed(0)
        : '0');

      currency.value = user.value.organization.preferredCurrency;

      const onUpgradeClick = () => {
        pushRoute({
          name: 'subscribe',
          query: {
            plan: SubscriptionSlugNickName.ProfessionalNew,
            users: getOrganizationUsersCount().toString(),
            interval: PlanNickName.Yearly,
          },
        });
      };

      const onStartTrialClick = async () => {
        showFreeTrialPreviewModal.value = true;
      };

      const onModalClose = async () => {
        showFreeTrialPreviewModal.value = false;
      };

      const startFreeTrial = () => {
        isLoading.value = true;
        startTrial()().then(() => {
          fetchUser()().then(() => {
            showFreeTrialPreviewModal.value = false;
            isLoading.value = false;
            pushRoute({ name: 'home' });
          });
        });
      };

      return {
        price,
        currency,
        showFreeTrialPreviewModal,
        isLoading,
        getList,
        onUpgradeClick,
        onStartTrialClick,
        onModalClose,
        startFreeTrial,
        csEmail: process.env.VUE_APP_CS_EMAIL,
      };
    },
  });
